module.exports = __webpack_public_path__ + "static/media/dharmendra.eaad615d.png";